class TestimonialsSlider extends HTMLElement{
    constructor(){
        super()
        this.wrapper_slider = this.querySelector('.testimonials-slider');
    }

    connectedCallback(){
        if(this.wrapper_slider != null){
            tns({
                container: this.wrapper_slider,
                items: 1,
                slideBy: 'page',
                controls:false
            });
        }
    }
}
customElements.define('testimonials-slider', TestimonialsSlider);